'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styled = require('./styled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toaster = function Toaster() {
  return _react2.default.createElement(
    _styled.ToasterContainer,
    null,
    _react2.default.createElement(
      _styled.ToasterWrapper,
      null,
      _react2.default.createElement(
        'p',
        null,
        'Test Toaster1'
      )
    ),
    _react2.default.createElement(
      _styled.ToasterWrapper,
      null,
      _react2.default.createElement(
        'p',
        null,
        'Test Toaster2'
      )
    )
  );
};

exports.default = Toaster;


//////////////////
// WEBPACK FOOTER
// ./node_modules/konsys-ui/dist/lib/toaster/index.js
// module id = 702
// module chunks = 0